/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferCustomersControllerGetCustomerQueryResponse, TransferCustomersControllerGetCustomerPathParams, TransferCustomersControllerGetCustomer400, TransferCustomersControllerGetCustomer401, TransferCustomersControllerGetCustomer403, TransferCustomersControllerGetCustomer404 } from "../../models/transferCustomersController/TransferCustomersControllerGetCustomer";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { transferCustomersControllerGetCustomer } from "../../clients/transfer-customersService/transferCustomersControllerGetCustomer";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const transferCustomersControllerGetCustomerQueryKey = (salesforceId: TransferCustomersControllerGetCustomerPathParams["salesforceId"]) => [{
  url: '/api/v1/transfer-customers/:salesforceId',
  params: {
    salesforceId: salesforceId
  }
}] as const;
export type TransferCustomersControllerGetCustomerQueryKey = ReturnType<typeof transferCustomersControllerGetCustomerQueryKey>;
export function transferCustomersControllerGetCustomerQueryOptions(salesforceId: TransferCustomersControllerGetCustomerPathParams["salesforceId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = transferCustomersControllerGetCustomerQueryKey(salesforceId);
  return queryOptions<TransferCustomersControllerGetCustomerQueryResponse, ResponseErrorConfig<TransferCustomersControllerGetCustomer400 | TransferCustomersControllerGetCustomer401 | TransferCustomersControllerGetCustomer403 | TransferCustomersControllerGetCustomer404>, TransferCustomersControllerGetCustomerQueryResponse, typeof queryKey>({
    enabled: !!salesforceId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return transferCustomersControllerGetCustomer(salesforceId, config);
    }
  });
}

/**
 * @summary Get customer details from 1.0 database
 * {@link /api/v1/transfer-customers/:salesforceId}
 */
export function useTransferCustomersControllerGetCustomer<TData = TransferCustomersControllerGetCustomerQueryResponse, TQueryData = TransferCustomersControllerGetCustomerQueryResponse, TQueryKey extends QueryKey = TransferCustomersControllerGetCustomerQueryKey>(salesforceId: TransferCustomersControllerGetCustomerPathParams["salesforceId"], options: {
  query?: Partial<QueryObserverOptions<TransferCustomersControllerGetCustomerQueryResponse, ResponseErrorConfig<TransferCustomersControllerGetCustomer400 | TransferCustomersControllerGetCustomer401 | TransferCustomersControllerGetCustomer403 | TransferCustomersControllerGetCustomer404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? transferCustomersControllerGetCustomerQueryKey(salesforceId);
  const query = useQuery({
    ...transferCustomersControllerGetCustomerQueryOptions(salesforceId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TransferCustomersControllerGetCustomer400 | TransferCustomersControllerGetCustomer401 | TransferCustomersControllerGetCustomer403 | TransferCustomersControllerGetCustomer404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}